import getSummarySales from './getSummarySales';
import { distributePointByRatio } from 'utils';

export default function getProductSalesData(
  or = [],
  d1 = [],
  d2 = [],
  d3 = []
) {
  const orderMap = new Map();

  or.forEach((order) => {
    const amounts = order.product_information.map(
      (item) => item.payment_price + Math.abs(item.discount_price)
    );
    const pointRatio = distributePointByRatio(
      amounts,
      Math.abs(order.use_point)
    );

    order.product_information.forEach((item, index) => {
      const { product_name } = item;

      if (orderMap.has(product_name)) {
        orderMap.get(product_name).push({ ...item, point: pointRatio[index] });
      } else {
        orderMap.set(product_name, [{ ...item, point: pointRatio[index] }]);
      }
    });
  });

  const newList = [...d1, ...d2, ...d3];

  const productNames = [
    ...new Set(newList.map((item) => item.product.product_name)),
  ];

  const productList = productNames.reduce((acc, cur) => {
    acc[cur] = newList.filter((item) => item.product.product_name === cur);
    return acc;
  }, {});

  const summaryData = getSummarySales(productList);

  const newSummaryData = summaryData.map((item) => {
    const items = orderMap.get(item.key) ?? [];

    const totalPoint = items.reduce((acc, cur) => {
      acc += cur.point ?? 0;
      return acc;
    }, 0);

    return {
      ...item,
      totalDiscount: item.totalDiscount + totalPoint,
      totalDeliveryDiscount: item.totalDeliveryDiscount + totalPoint,
      totalPickupDiscount: item.totalPickupDiscount + totalPoint,
      totalSubscriptionDiscount: item.totalSubscriptionDiscount + totalPoint,
      totalRentalDiscount: item.totalRentalDiscount + totalPoint,
    };
  });

  return newSummaryData;
}
